import _ from 'lodash';
import React from 'react';

import Page from 'components/Page';
import {Container} from 'containers/types';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import VisibleIf from 'components/VisibleIf';

import {PERMISSIONS} from 'ducks/auth';

import {SummarySection, RevenueOverviewSection} from './components';

import './styles.css';
import {SUMMARY_RESOLUTION_OPTIONS} from 'ducks/reporting';

class RevenueReporting extends React.Component<Container & LoginRequiredProps> {
  state = {
    summaryResolution: SUMMARY_RESOLUTION_OPTIONS.CURRENT_MONTH
  };

  onSummaryResolutionChange = (
    summaryResolution,
    fetchRevenueSummaryCallback
  ) => {
    if (this.state.summaryResolution === summaryResolution) {
      return;
    }

    this.setState({summaryResolution}, fetchRevenueSummaryCallback);
  };

  render() {
    const {summaryResolution} = this.state;
    const {locationRef} = this.props.match.params;

    return (
      <Page activeTab="revenueReporting" locationRef={locationRef}>
        <VisibleIf
          permission={PERMISSIONS.VIEW_REVENUE_REPORTING}
          locationRef={locationRef}>
          <div className="RevenueReporting">
            <div className="RevenueReporting__container">
              <SummarySection
                locationRef={locationRef}
                summaryResolution={summaryResolution}
                onSummaryResolutionChange={this.onSummaryResolutionChange}
              />
              <RevenueOverviewSection
                locationRef={locationRef}
                summaryResolution={summaryResolution}
              />
            </div>
          </div>
        </VisibleIf>
      </Page>
    );
  }
}

export default LoginRequired(RevenueReporting);
